<template>
  <!--  添加和编辑项目  -->
  <el-dialog :title="edittype?'新增项目':'编辑项目'" :visible.sync="showEdit" :width="isBzjz||isNewProject?'400px':'600px'" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
<!--    <div v-if="edittype" style="font-size: 14px;color: #000000">当前暂无项目，请输入项目名称以新建项目：</div>-->
    <el-form :model="form" :rules="rules" ref="form">
      <div>
        <div v-if="isNewProject" style="font-size: 14px;color: #000000;margin-bottom:10px">当前暂无项目，请输入项目名称以新建项目：</div>
        <div v-else style="font-size: 14px;color: #000000;margin-bottom:10px">请{{edittype?'输入新增':'修改'}}项目名称：</div>
        <div>
          <el-form-item prop="projectName">
            <el-input v-model="form.projectName" placeholder="请输入"></el-input>
            <input type='text' style='display:none'/>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button class="checkbutton" @click="showEdit = false">取消{{edittype?'新增':'编辑'}}</el-button>
      <el-button class="checkbuttons" @click="edit">确认{{edittype?'新增':'编辑'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {api} from '@/api/apiRecord.js'
export default {
  name: "projectEdit",
  components: {
  },
  data(){
    return {
      showEdit:false,
      loading:false,
      form:{
        projectName:'',
      },
      edittype:false,//是否是编辑状态
      rules:{
        projectName:[
          { pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '只能输入中文、英文、数字' },
          { validator: (rule, value, callback) => {
              if (value.length>15) callback(new Error('最多15位字符'));
              else if (value.length==0) callback(new Error('请输入项目名称!'));
              else callback();
            }, trigger: 'blur' }
        ]
      },
      type:this.$route.query.type?this.$route.query.type:1,//当前页面进入模式1.个人记工2.班组记工
    }
  },
  props:{
      isBzjz: {
      type: [Boolean],
      default: false
    },
      isNewProject: {
      type: [Boolean],
      default: false
    }
  },
  methods:{
    open(form={projectName:''}){
      this.loading=false;
      this.showEdit=true;
      this.form={...form};
      this.edittype=!form.projectName;
      this.$refs.form&&this.$refs.form.clearValidate();
    },
    async edit(){
      if(this.loading)return;
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.form.userNo=this.$store.state.user.no;
        this.form.type=this.type;//1:个人记工,2:班组记工3:个人记账,,4:班组记账
        if(this.isBzjz){
        this.form.type='4';//1:个人记工,2:班组记工3:个人记账,,4:班组记账
        }
        this.loading=true;
        let res=await api.addTenderMoney(this.form);
        if(res.data.code==200){
          this.showEdit=false;
          this.$message.success(res.data.msg);
          this.$emit('editend',res.data.data)
        }else{
          this.$message.error(res.data.msg);
          this.loading=false;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body{
  padding-bottom: 0;
}
/deep/.el-dialog__footer{
  padding-top: 0;
  padding-bottom: 20px;
}
/deep/.el-button+.el-button {
  margin-left: 15px;
}
/deep/.el-input__inner{
  height: 34px;
  line-height: 34px;
}
/deep/.checkbutton{
  color: #969696 !important;
  background: #fff;
  border-color:#E4E7ED !important;
  width: 86px;
  height: 34px;
  line-height: 34px;
  padding:0;
  &:hover{
  color: #969696 !important;
  background: #fff;
  border-color:#E4E7ED !important;
  }
}
  .checkbuttons {
    color: #fff!important;
    border-color: #B79255;
    background: #B79255;
    width: 86px;
    height: 34px;
    line-height: 34px;
    padding: 0;
    font-size: 14px;
    &:hover,&:focus{
    color: #fff!important;
    border-color: #B79255;
    background: #B79255;
    }
  }
</style>
